export default __webpack_public_path__ + "static/media/ds-logo.012c2582.svg";